import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginPageComponent } from './core/components/login-page/login-page.component';
import { MainComponent } from './core/components/main/main.component';

const routes: Routes = [
  // ===== HỆ THỐNG QUẢN LÝ (đường dẫn bí mật) =====
  {
    path: 'fox-admin/login',
    component: LoginPageComponent,
  },
  {
    path: 'fox-admin',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/kurashima/kurashima.module').then(
            (mod) => mod.KurashimasModule
          ),
      },
    ],
  },

  // ===== TRANG PUBLIC (mặc định, không cần đăng nhập) =====
  {
    path: '',
    loadChildren: () =>
      import('./features/public/public.module').then((mod) => mod.PublicModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
